import { flatbizPrice } from '@flatbiz/utils';
import { FC, ReactElement, useState } from 'react';
import { useEffectCustom } from '../../hooks/use-effect-custom';
import { NativeProps, withNativeProps } from '../../utils/native-props';
import './style.less';

export type AmountProps = {
  isFen?: number;
  value?: number | string;
  // (string & {}) 保证 $ | ¥语法提示正常
  prefix?: '¥' | '$' | (string & {});
  /**
   * 精确显示
   * remove-tail-zero / 最多保留2位，但去除小数后尾号零
   * split / 保留2位并拆开显示（例如88.90，其中90显示较小）
   * 默认： 保留2位（默认值）
   */
  precision?: 'remove-tail-zero' | 'split';
  defaultValue?: string | number;
  extra?: string | ReactElement;
} & NativeProps;

/**
 * 金额显示
 * ```
 * 精确显示 precision类型
 * 1. 保留2位（默认值）
 * 2. 最多保留2位，但去除小数后尾号零
 * 3. 保留2位并拆开显示（例如88.90，其中90显示较小）
 * ```
 */
export const Amount: FC<AmountProps> = (props) => {
  const [splitValue, setSplitValue] = useState<string[]>();
  const [value, setValue] = useState('-');

  useEffectCustom(() => {
    let value = props.value;
    if (!value) {
    }
    if (props.isFen) {
      value = flatbizPrice.fen2yuan(value, props.defaultValue);
    }
    if (props.precision === 'split') {
      setSplitValue(flatbizPrice.split(value, props.defaultValue));
    } else if (props.precision === 'remove-tail-zero') {
      setValue(flatbizPrice.removeTailZero(value, props.defaultValue));
    } else {
      setValue(flatbizPrice.format(value, props.defaultValue));
    }
  }, [props.value, props.isFen, props.precision, props.defaultValue]);

  if (splitValue && splitValue.length > 0) {
    return withNativeProps(
      props,
      <span className="v-amount">
        {props.prefix && <span className="v-amount-prefix">{props.prefix}</span>}
        <span className="v-amount-split">
          {splitValue.map((item, index) => {
            return <span key={index}>{item}</span>;
          })}
        </span>
        {props.extra ? <span className="v-amount-extra">{props.extra}</span> : null}
      </span>,
    );
  }

  return withNativeProps(
    props,
    <span className="v-amount">
      {props.prefix && <span className="v-amount-prefix">{props.prefix}</span>}
      <span className="v-amount-value">{value}</span>
      {props.extra ? <span className="v-amount-extra">{props.extra}</span> : null}
    </span>,
  );
};

Amount.defaultProps = {
  prefix: '¥',
};
